// polyfill for event
(function () {
    if ( typeof window.CustomEvent === "function" ) return false; //If not IE
  
    function CustomEvent ( event, params ) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent( 'CustomEvent' );
      evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
      return evt;
     }
  
    CustomEvent.prototype = window.Event.prototype;
  
    window.CustomEvent = CustomEvent;

    //polyfill for classList
    if (!("classList" in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
      Object.defineProperty(HTMLElement.prototype, 'classList', {
          get: function() {
              var self = this;
              function update(fn) {
                  return function(value) {
                      var classes = self.className.split(/\s+/),
                          index = classes.indexOf(value);

                      fn(classes, index, value);
                      self.className = classes.join(" ");
                  }
              }

              var ret = {                    
                  add: update(function(classes, index, value) {
                      ~index || classes.push(value);
                  }),

                  remove: update(function(classes, index) {
                      ~index && classes.splice(index, 1);
                  }),

                  toggle: update(function(classes, index, value) {
                      ~index ? classes.splice(index, 1) : classes.push(value);
                  }),

                  contains: function(value) {
                      return !!~self.className.split(/\s+/).indexOf(value);
                  },

                  item: function(i) {
                      return self.className.split(/\s+/)[i] || null;
                  }
              };
              
              Object.defineProperty(ret, 'length', {
                  get: function() {
                      return self.className.split(/\s+/).length;
                  }
              });

              return ret;
          }
      });
    }

    //polyfill for includes
    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        'use strict';
    
        if (search instanceof RegExp) {
          throw TypeError('first argument must not be a RegExp');
        }
        if (start === undefined) { start = 0; }
        return this.indexOf(search, start) !== -1;
      };
    }

    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
          value: function(predicate) {var o = Object(this);
            var len = o.length >>> 0;
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
              var kValue = o[k];
              if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
              }
              k++;
            }
            return undefined;
          },
          configurable: true,
          writable: true
        });
      }
      if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function () {
          if (this.parentNode) {
            this.parentNode.removeChild(this);
          }
        };
      }
      if (window.Element && !Element.prototype.closest) {
        Element.prototype.closest =
          function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i,
              el = this;
            do {
              i = matches.length;
              while (--i >= 0 && matches.item(i) !== el) {};
            } while ((i < 0) && (el = el.parentElement));
            return el;
          };
      }
  })();